import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from "../Reusablecomponents/Card";
import BackButton from "../Reusablecomponents/BackButton";
import ToastPopup from "../popups/ToastPopup";
import "../css/others/Table.css";
import "../css/others/Card.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import FunctionRescheduleMeetingPopup from "../popups/FunctionRescheduleMeetingPopup";
import IconComponent from "../Reusablecomponents/IconComponent";
import { FunctionCampaignDetailsInformation, IFunctionChecklistItem, RescheduleData, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import EncryptionUtils from "../main/encryptionUtils";
const FunctionCampaignDetailsInfo: React.FC = () => {
    const [campaign, setCampaign] = useState<FunctionCampaignDetailsInformation | null>(null);
    const [originalCampaign, setOriginalCampaign] = useState<FunctionCampaignDetailsInformation | null>(null);
    const [, setError] = useState<string | null>(null);
    const [showReschedulePopup, setShowReschedulePopup] = useState(false);
    const [message, setMessage] = useState<ToastMessage | null>(null);
    const [isEditing, setIsEditing] = useState(false);
    const [auditorList, setAuditorList] = useState<{ id: string; name: string; isPrimaryAuditor: boolean; userStatus: string }[]>([]);
    const [checklistOptions, setChecklistOptions] = useState<IFunctionChecklistItem[]>([]);
    const [editableFields, setEditableFields] = useState<string[]>([]);
    const { functionId, campaignId } = useParams<{ functionId: string; campaignId: string }>();
    const clientId = localStorage.getItem("clientId");
    const userEmail = localStorage.getItem("email");
    const updatedBy = localStorage.getItem("email");
    const { roleName, userRole } = EncryptionUtils.getAuthInfo();
    const [, setAuditorRoleId] = useState<string>("");
    const getEditableFields = React.useCallback((): string[] => {
        const baseEditableFields = ["primaryAuditorName", "secondaryAuditorName", "assignedCheckList"];
        if (
            userRole === 'Admin' || userRole === 'Primary Spoc' || userRole === 'Secondary Spoc' || userRole === 'Super Admin'
        ) {
            return baseEditableFields;
        }
        return [];
    }, [userRole]);
    const getActiveAuditors = React.useCallback(() => {
        return auditorList.filter(auditor => auditor.userStatus === "ACTIVE");
    }, [auditorList]);
    const getPrimaryAuditors = React.useCallback(() => {
        return getActiveAuditors().filter(auditor => auditor.isPrimaryAuditor === true);
    }, [getActiveAuditors]);
    const getSecondaryAuditors = React.useCallback(() => {
        return getActiveAuditors().filter(auditor => auditor.isPrimaryAuditor === false);
    }, [getActiveAuditors]);
    useEffect(() => {
        setEditableFields(getEditableFields());
        if (!functionId || !campaignId) {
            setError("Function ID or Campaign ID is missing.");
            return;
        }
        apiCall("get", `/api/campaign-functions?campaignId=${campaignId}&functionId=${functionId}`)
            .then((response) => {
                if (response) {
                    setCampaign(response);
                    setOriginalCampaign(response);
                } else {
                    console.error("Campaign not found.");
                }
            })
            .catch((error) => {
                console.error("Error fetching campaign details:", error);
            });
        apiCall("get", `/api/roles/all/${clientId}`)
            .then((roles) => {
                const auditorRole = roles.find((role: any) => role.name === "Auditor");
                if (!auditorRole) {
                    throw new Error("Auditor role not found");
                }
                setAuditorRoleId(auditorRole.id);
                return apiCall("get", `/api/users/names?clientId=${clientId}`, null, { roleId: auditorRole.id });
            })
            .then((response) => {
                const auditors = response.map((auditor: any) => ({ id: auditor.id, name: auditor.name, isPrimaryAuditor: auditor.isPrimaryAuditor, userStatus: auditor.userStatus }));
                setAuditorList(auditors);
            })
            .catch((error) => {
                console.error("Error fetching roles or auditors:", error);
            });
        apiCall("get", `/api/function-template?clientId=${clientId}&status=ACTIVE`)
            .then((response) => {
                setChecklistOptions(response.content || []);
            })
            .catch((error) => {
                console.error("Error fetching checklist options:", error);
            });
    }, [functionId, campaignId, clientId, getEditableFields]);
    const handleRescheduleMeeting = () => setShowReschedulePopup(true);
    const handleCloseReschedulePopup = () => setShowReschedulePopup(false);
    const handleRescheduleSubmit = async (data: RescheduleData) => {
        if (!userEmail) {
            setMessage(createToastMessage("User email not found.", "error", 3000));
            return;
        }
        const payload = { eventId: data.eventId, newStartTime: data.newStartTime, newEndTime: data.newEndTime, timezone: data.timezone, updatedAttendees: data.updatedAttendees, sendUpdates: "all", rescheduledBy: userEmail, loggedInEmail: userEmail };
        try {
            await apiCall("post", "/api/meetings/reschedule", payload);
            setMessage(createToastMessage("Meeting rescheduled successfully.", "success", 3000));
            setShowReschedulePopup(false);
            setTimeout(() => window.location.reload(), 3000);
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || "Failed to reschedule meeting. Please try again.";
            setMessage(createToastMessage(errorMessage, "error", 3000));
        }
    };
    const handleEdit = () => setIsEditing(true);
    const handleSave = () => {
        if (!campaign || !originalCampaign) return;
        const payload: any = { campaignId, functionId, updatedBy };
        let hasChanges = false;
        if (campaign.assignedCheckList !== originalCampaign.assignedCheckList) {
            payload['assignedCheckList'] = campaign['assignedCheckListId'];
            hasChanges = true;
        }
        if (campaign.assignedCheckList) {
            if (campaign.secondaryAuditorName && !campaign.primaryAuditorName) {
                setMessage(createToastMessage("Please select Primary Auditor before selecting Secondary Auditor.", "warning", 3000));
                return;
            }
            if (campaign.primaryAuditorName !== originalCampaign.primaryAuditorName) {
                payload['primaryAuditorName'] = campaign['primaryAuditorName'];
                payload['primaryAuditorId'] = campaign['primaryAuditorId'];
                hasChanges = true;
            }
            if (campaign.secondaryAuditorName !== originalCampaign.secondaryAuditorName) {
                payload['secondaryAuditorName'] = campaign['secondaryAuditorName'];
                payload['secondaryAuditorId'] = campaign['secondaryAuditorId'];
                hasChanges = true;
            }
        } else {
            if (campaign.primaryAuditorName || campaign.secondaryAuditorName) {
                setMessage(createToastMessage("Please assign a checklist before assigning auditors.", "warning", 3000));
                return;
            }
        }
        if (!hasChanges) {
            setMessage(createToastMessage("No changes detected.", "warning", 3000));
            setIsEditing(false);
            return;
        }
        apiCall("patch", "/api/campaign-functions", payload)
            .then(() => {
                setMessage(createToastMessage("Changes saved successfully!", "success", 3000));
                setOriginalCampaign(campaign);
                setIsEditing(false);
            })
            .catch((error: any) => {
                const errorMessage = error?.response?.data?.message;
                setMessage(createToastMessage(errorMessage, "error", 3000));
            });
    };
    const handleCancel = () => { setCampaign(originalCampaign); setIsEditing(false) };
    const handleFieldChange = (key: string, value: any) => {
        if (!campaign) return;
        if (key === 'primaryAuditorName') {
            const selectedAuditor = getActiveAuditors().find(auditor => auditor.name === value);
            const emailMatch = value.match(/\(([^)]+)\)/);
            const email = emailMatch ? emailMatch[1] : value;
            setCampaign({ ...campaign, [key]: email, primaryAuditorId: selectedAuditor?.id || '', ...(value === campaign.secondaryAuditorName ? { secondaryAuditorName: '', secondaryAuditorId: '' } : {}) });
        }
        else if (key === 'secondaryAuditorName') {
            if (!campaign.primaryAuditorName) {
                setMessage(createToastMessage("Please select Primary Auditor first before selecting Secondary Auditor.", "warning", 3000));
                return;
            }
            const selectedAuditor = getActiveAuditors().find(auditor => auditor.name === value);
            const emailMatch = value.match(/\(([^)]+)\)/);
            const email = emailMatch ? emailMatch[1] : value;
            if (email === campaign.primaryAuditorName) {
                setMessage(createToastMessage("Secondary auditor cannot be the same as primary auditor.", "error", 3000));
                return;
            }
            setCampaign({ ...campaign, [key]: email, secondaryAuditorId: selectedAuditor?.id || '' });
        }
        else if (key === 'assignedCheckList') {
            const selectedTemplate = checklistOptions.find(item => item.functionCheckListName === value);
            setCampaign({ ...campaign, [key]: value, assignedCheckListId: selectedTemplate?.functionTemplateId || '' });
        }
        else {
            setCampaign({ ...campaign, [key]: value });
        }
    };
    const displayFields = ["functionName", "functionHeadName", "functionHeadEmail", "functionSpocName", "functionSpocEmail", "primaryAuditorName", "secondaryAuditorName", "functionCampaignStartDate", "functionCampaignEndDate", "assignedCheckList", "auditStatus", "createdDate", "updatedDate"];
    const isAdmin = userRole === 'Admin' || userRole === 'Primary Spoc' || userRole === 'Secondary Spoc' || userRole === 'Super Admin';
    const hasPrimaryAuditor = campaign?.primaryAuditorName;
    return (
        <div className="container">
            <div className="inner-container">
                <h2 className="title">Function Details Information</h2>
                {!campaign ? (
                    <p className="loading">Loading function campaign details...</p>
                ) : (
                    <>
                        {roleName && ["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin"].includes(roleName) && campaign.isMeetingScheduled && campaign.campaignStatus !== "CLOSED" && campaign.auditStatus === "NOT_STARTED" && (
                            <button className="reschedule-meeting" onClick={handleRescheduleMeeting}>Reschedule Meeting</button>
                        )}
                        {isEditing ? (
                            <>
                                <button className="save" onClick={handleSave}>Save</button>
                                <button className="cancel" onClick={handleCancel}>Cancel</button>
                            </>
                        ) : (
                            isAdmin && editableFields.length > 0 && campaign.campaignStatus !== "CLOSED" && campaign.auditStatus === "NOT_STARTED" && (
                                <button className="edit" onClick={handleEdit}>Edit</button>
                            )
                        )}
                    </>
                )}
            </div>
            {campaign && (
                <div className="grid">
                    {isAdmin && editableFields.length > 0 && campaign.campaignStatus !== "CLOSED" && campaign.auditStatus === "NOT_STARTED" && (
                        <h3 className="editfield">Editable Fields</h3>
                    )}
                    {isAdmin && editableFields
                        .filter(key => displayFields.includes(key))
                        .map((key) => {
                            const value = campaign[key];
                            const label = key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());
                            return (
                                <Card key={key} label={label} value={isEditing ? (
                                    key === 'primaryAuditorName' ? (
                                        <select value={campaign.primaryAuditorName ? getActiveAuditors().find(a => a.name.includes(campaign.primaryAuditorName))?.name || '' : ''} onChange={(e) => handleFieldChange(key, e.target.value)} className="edit-input">
                                            <option value="">Select Primary Auditor</option>
                                            {getPrimaryAuditors().map((auditor) => (
                                                <option key={auditor.id} value={auditor.name}>{auditor.name}</option>
                                            ))}
                                        </select>
                                    ) : key === 'secondaryAuditorName' ? (
                                        <select value={campaign.secondaryAuditorName ? getActiveAuditors().find(a => a.name.includes(campaign.secondaryAuditorName))?.name || '' : ''} onChange={(e) => handleFieldChange(key, e.target.value)} className="edit-input" disabled={!hasPrimaryAuditor} title={!hasPrimaryAuditor ? "Select Primary Auditor first" : ""}>
                                            <option value="">Select Secondary Auditor</option>
                                            {getSecondaryAuditors().map((auditor) => (
                                                <option key={auditor.id} value={auditor.name}>{auditor.name}</option>
                                            ))}
                                        </select>
                                    ) : key === 'assignedCheckList' ? (
                                        <select value={value || ''} onChange={(e) => handleFieldChange(key, e.target.value)} className="edit-input">
                                            <option value="">Select Checklist</option>
                                            {checklistOptions.map((item) => (
                                                <option key={item.functionTemplateId} value={item.functionCheckListName}>{item.functionCheckListName}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input type="text" value={value || ""} onChange={(e) => handleFieldChange(key, e.target.value)} className="edit-input" />
                                    )
                                ) : (value || "N/A")}
                                    icon={<IconComponent name={key} className="icon" />}
                                />
                            );
                        })}
                    {isAdmin && campaign.campaignStatus !== "CLOSED" && campaign.auditStatus === "NOT_STARTED" && (
                        <h3 className="editfield">Non Editable Fields</h3>
                    )}
                    {displayFields
                        .filter(key => !editableFields.includes(key))
                        .map((key) => {
                            const value = campaign[key];
                            const label = key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());
                            return (
                                <Card key={key} label={label} value={value || "N/A"} icon={<IconComponent name={key} className="icon" />} />
                            );
                        })}
                </div>
            )}
            <div className="buttons">
                <BackButton className="back-button2" label="Back" />
            </div>
            {showReschedulePopup && campaign && (
                <FunctionRescheduleMeetingPopup handleClose={handleCloseReschedulePopup} handleSubmit={handleRescheduleSubmit} campaignDetails={campaign} />
            )}
            {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
        </div>
    );
};
export default FunctionCampaignDetailsInfo;